import {
  useMutation,
  useInfiniteQuery,
  useQueryClient,
} from '@tanstack/react-query'
import type {
  UserUserInboxListMessagesParams,
  UserInboxMarkReadInput,
  UserInboxMarkAllReadInput,
} from '../api'
import type { IMutationArgs } from '../types'
import { userInboxListMessagesOptionsPre } from './user-inbox.options'
import { EUserInboxQueryKey } from './user-inbox.types'
import userOtcService from './user-inbox.service'

export const useUserInboxMarkAsRead = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args

  return useMutation({
    mutationFn: (data: UserInboxMarkReadInput) =>
      userOtcService.userInboxMarkAsRead(data),
    mutationKey: [EUserInboxQueryKey.USER_INBOX_MARK_AS_READ],
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({
          queryKey: [EUserInboxQueryKey.USER_INBOX_LIST_MESSAGES],
        })

      return data
    },
  })
}

export const useUserInboxMarkAllAsRead = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args

  return useMutation({
    mutationFn: (data: UserInboxMarkAllReadInput) =>
      userOtcService.userInboxMarkAllAsRead(data),
    mutationKey: [EUserInboxQueryKey.USER_INBOX_MARK_ALL_AS_READ],
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({
          queryKey: [EUserInboxQueryKey.USER_INBOX_LIST_MESSAGES],
        })
      return data
    },
  })
}

export const useUserInboxListMessages = (
  params: UserUserInboxListMessagesParams,
) => {
  return useInfiniteQuery(userInboxListMessagesOptionsPre(params))
}
